
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: 'head-bar',
components: {
XHeader,
},
props: {
title: String,
headBackground: {
default: '#fff',
type: String,
},

backType: {
default: 'blue',
type: String,
},
backText: String,   // 左侧按钮文本
rightText: String,  // 右侧按钮文本

customIcon: {
type: Boolean,
default: false,
},
setBorder: {
type: Boolean,
default: true,
}
},
methods: {
onBack(){
if(!this.backText && !this.customIcon && window.history.length <= 1){
window.location.href = this.$store.state.WAP_HOST;
}

this.$emit('on-back');
},

/** 点击右侧更多时触发 */
onClickMore(){
this.$emit('on-click-more');
},
}
}



// WEBPACK FOOTER //
// ./src/components/HeadBar/HeadBar.vue